export const BLOG_CATEGORIES = [
  'General Health',
  'Diabetes',
  'Heart Health',
  'Physiotherapy',
  'Home Care',
  'Women\'s Health',
  'Child Health',
  'Mental Health',
  'Nutrition & Diet',
  'Skin Care',
  'Elderly Care',
  'Fitness',
];

export const BLOG_STATUS_STYLES = {
  draft: { label: 'Draft', className: 'bg-slate-100 text-slate-700' },
  pending: { label: 'Pending approval', className: 'bg-amber-100 text-amber-800' },
  published: { label: 'Published', className: 'bg-emerald-100 text-emerald-700' },
  rejected: { label: 'Needs changes', className: 'bg-red-100 text-red-700' },
};

export const formatBlogDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '';

export const readingTime = (html = '') =>
  Math.max(1, Math.round(html.replace(/<[^>]+>/g, ' ').split(/\s+/).filter(Boolean).length / 200));

export const specLabel = (s) => (s || '').trim().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const authorName = (name, role) =>
  `${role === 'doctor' && !/^dr/i.test((name || '').trim()) ? 'Dr. ' : ''}${(name || '').trim() || 'Physign Team'}`;
